/**
 * Validation Rules Utilities
 *
 * Build Ant Design validation rules from field metadata.
 * Uses ONLY fields that exist in backend FieldDefinition.
 */

import type { Rule } from 'antd/es/form'
import type { FieldMetadata } from '@/services/metadataService'

/**
 * Build Ant Design validation rules from field metadata
 */
export function buildValidationRules(fieldName: string, metadata: FieldMetadata): Rule[] {
  const rules: Rule[] = []

  // Required fields
  if (metadata.required_on_create) {
    rules.push({
      required: true,
      message: `${metadata.title || fieldName} is required`,
    })
  }

  // String length constraints
  if (metadata.py_type === 'string') {
    if (metadata.min_length) {
      rules.push({
        min: metadata.min_length,
        message: `${metadata.title || fieldName} must be at least ${metadata.min_length} characters`,
      })
    }
    if (metadata.max_length) {
      rules.push({
        max: metadata.max_length,
        message: `${metadata.title || fieldName} must be ${metadata.max_length} characters or less`,
      })
    }
  }

  // Numeric constraints
  if (['integer', 'numeric', 'int', 'float', 'Decimal'].includes(metadata.py_type)) {
    if (metadata.min_value !== undefined && metadata.min_value !== null) {
      rules.push({
        type: 'number',
        min: metadata.min_value,
        message: `${metadata.title || fieldName} must be at least ${metadata.min_value}`,
      })
    }

    if (metadata.max_value !== undefined && metadata.max_value !== null) {
      rules.push({
        type: 'number',
        max: metadata.max_value,
        message: `${metadata.title || fieldName} must be at most ${metadata.max_value}`,
      })
    }
  }

  // Custom regex validation (from YAML regex field)
  if (metadata.regex) {
    rules.push({
      pattern: new RegExp(metadata.regex),
      message: `${metadata.title || fieldName} format is invalid`,
    })
  }

  return rules
}
